const RedirectToPlayStore = () => {
    window.location.href = "https://play.google.com/store/apps/details?id=com.sse.solarpro_referral&hl=en-IN";
};
export default RedirectToPlayStore;